module.exports = __webpack_public_path__ + "static/thumbnail-ede7b4a8f2b8bb8d7704d23817b3464c.png";